import { IOrderBillClaimEntity } from './orderBillClaim.entity.interface';

export class OrderBillClaimEntity implements IOrderBillClaimEntity {
  readonly idNumber: string;

  constructor(data: IOrderBillClaimEntity) {
    this.idNumber = data.idNumber;
  }
}
